import {
  formatDateOnly,
  formatDateOnlyLong,
  formatDateRangeShort,
  formatDateShort,
  formatDateTime,
  formatDateTimeLong,
  formatDateTimeRelative,
  formatTimeOnly,
} from './date.formatter'
import { formatMoney, getCurrencySymbol } from './money.formatter'
import { formatNumber } from './number.formatter'

export {
  diffDates,
  formatDateOnly,
  formatDateOnlyLong,
  formatDateRangeShort,
  formatDateShort,
  formatDateTime,
  formatDateTimeLong,
  formatDateTimeRelative,
  formatTimeOnly,
} from './date.formatter'
export {
  formatLongValue,
  type FormatMetricOptions,
  formatShortValue,
  type MetricFormat,
  type MetricValue,
  metricValueToNumber,
} from './metric.formatter'
export { formatMoney, formatMoneyMinor, getCurrencySymbol } from './money.formatter'
export { formatNumberValue } from './number.core'
export { formatNumber } from './number.formatter'
export const defaultFormatter = {
  formatDateOnly,
  formatDateOnlyLong,
  formatDateRangeShort,
  formatDateShort,
  formatDateTime,
  formatDateTimeLong,
  formatDateTimeRelative,
  formatTimeOnly,
  formatMoney,
  getCurrencyLabel: getCurrencySymbol,
  formatNumber,
}
